import AppLayout from "@/layouts/AppLayout";
import Breadcrumb from "@/components/Breadcrumb";
import PageTitle from "@/components/PageTitle";
import { FacilityDetailsHeader } from "../_components/FacilityDetailsHeader";
import { useFacilityNavLinks } from "../_utils";
import { Outlet, useLocation, useParams } from "react-router-dom";

export default function FacilityAdminToolsLayout() {
  const { facilityId } = useParams();
  const location = useLocation();
  const navLinks = useFacilityNavLinks(facilityId);

  if (!facilityId) return null;

  return (
    <AppLayout navLinks={navLinks} interior bottomBar>
      <Breadcrumb
        compactOnly
        compactTitle="Admin Tools"
        backLink={{
          to: "/facilities/:facilityId",
          params: { facilityId }
        }}
      />
      <PageTitle pattern={location.pathname} title="Facilities | Facility Details | Admin Tools" />
      <FacilityDetailsHeader facilityId={facilityId} />
      <Outlet />
    </AppLayout>
  );
}
